
<template>
	<article class="content">
		<!-- survey gizmo iframe -->
		<iframe :src="'https://surveys.tektronix.com/s3/' + surveyId + ''" frameborder="0" style="width:100vw; height:calc(100vh - 65px); overflow:hidden"></iframe>
	</article>
</template>

<script>
export default {
	name: 'Survey',
	computed:{
		surveyId(){
			return this.$route.params.surveyId;
		}
	}
};

</script>

<style scoped>
	.content {
		margin: 0;
	}
</style>



// WEBPACK FOOTER //
// ./src/views/Survey.vue